// extracted by mini-css-extract-plugin
export default {"rankCell":"RankCell_rankCell__UgaK9","rankMedal":"RankCell_rankMedal__JLre-","rankNum":"RankCell_rankNum__LoNBy"};